import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Credentials from './Credentials';
import Details from './Details';
import Settings from './Settings';
import { RootLayout } from 'components';
import { Container } from 'semantic';
import useMenuRoutes from 'hooks/useMenuRoutes';
import { useUser } from 'contexts/user';

export default function Providers({ routesContext = 'legacy' }) {
  const { provider } = useUser();
  const { providerRoutes } = useMenuRoutes(routesContext);
  const { apiRoute } = providerRoutes;

  if (provider?.environment !== 'sandbox') {
    return <Redirect to="/" />;
  }

  return (
    <RootLayout>
      <Container>
        <Switch>
          <Route
            path={`/sandbox/credentials`}
            component={(props) => (
              <Credentials {...props} apiRoute={apiRoute} />
            )}
            exact
          />
          <Route
            path={`/sandbox/settings`}
            component={(props) => <Settings {...props} apiRoute={apiRoute} />}
            exact
          />
          <Route
            path={`/sandbox/settings/*`}
            component={(props) => <Settings {...props} apiRoute={apiRoute} />}
            exact
          />
          <Route
            path={`/sandbox`}
            component={(props) => <Details {...props} apiRoute={apiRoute} />}
            exact
          />
        </Switch>
      </Container>
    </RootLayout>
  );
}
